import { render, staticRenderFns } from "./ContentText.vue?vue&type=template&id=a983cee2&scoped=true&"
import script from "./ContentText.vue?vue&type=script&lang=js&"
export * from "./ContentText.vue?vue&type=script&lang=js&"
import style0 from "./ContentText.vue?vue&type=style&index=0&id=a983cee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a983cee2",
  null
  
)

/* custom blocks */
import block0 from "./ContentText.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports